"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormService = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var store_1 = require("../store");
var index_1 = require("./index");
var FormService = /** @class */ (function () {
    function FormService() {
        this.__priority = 100;
    }
    /**
     * Saves a form.
     *
     * @returns New, saved, form.
     */
    FormService.prototype.save = function (form) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, formJSON, newFormJSON;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = index_1.Services.Department.rest;
                        formJSON = core_shared_1.IkeModel.Form.write(form);
                        return [4 /*yield*/, rest.save(rest.Objects.Form, formJSON)];
                    case 1:
                        newFormJSON = _a.sent();
                        return [2 /*return*/, core_shared_1.IkeModel.Form.read(newFormJSON)];
                }
            });
        });
    };
    /**
     * Deletes a form.
     *
     * @returns Revision of deleted form.
     */
    FormService.prototype.remove = function (uuid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, startTime, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = index_1.Services.Department.rest;
                        startTime = Date.now();
                        return [4 /*yield*/, rest.Form.delete({ uuid: uuid })];
                    case 1:
                        result = _a.sent();
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Form, 'FORM_DELETE', "uuid: ".concat(uuid), Date.now() - startTime);
                        store_1.AppStore.FormSummary.refresh();
                        return [2 /*return*/, result.results.revision];
                }
            });
        });
    };
    /**
     * Shares a form with another department of the same organization.
     *
     * @returns New form revision.
     */
    FormService.prototype.share = function (revision, toDepartmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, startTime, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = index_1.Services.Department.rest;
                        startTime = Date.now();
                        return [4 /*yield*/, rest.Form.share({ revision: revision, toDepartmentId: toDepartmentId })];
                    case 1:
                        result = _a.sent();
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Form, 'FORM_SHARE', "revision:".concat(revision, " -> department:").concat(toDepartmentId), Date.now() - startTime);
                        return [2 /*return*/, result.results.revision];
                }
            });
        });
    };
    return FormService;
}());
exports.FormService = FormService;
//# sourceMappingURL=form.service.js.map